import script from "./EditServiceModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditServiceModal.vue?vue&type=script&setup=true&lang=ts"

import "./EditServiceModal.vue?vue&type=style&index=0&id=3a0920e7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a0920e7"]])

export default __exports__